export const handleChangeDataSheetProductComments = (name, value) => ({
    type: 'CHANGE_DATA_SHEET_PRODUCT_COMMENTS', name, value
});